import React, { Component } from "react";
import $ from "jquery";
import PdfViewer from "./PdfViewer";
import moment from "moment";

class ReportProdOpenDocs extends Component {
    //#region Component Actions
    constructor(props) {
        super(props);
        this.state = {
            filters: {
                Report: "ProdOpenDocs",
                DateStart: moment().add(-1, "months").format("YYYY-MM-DD"),
                DateEnd: moment().format("YYYY-MM-DD"),
                Status: "",
            }
        };
    }

    close() {
        $("#ReportProdOpenDocs").modal("hide");
    }

    updateField = (field, value) => {
        let filters = Object.assign({}, this.state.filters);
        filters[field] = value;
        this.setState({ filters });
    }

    validateFilters = () => {
        const { filters } = this.state;
        const { showAlert, GenerateReport } = this.props;

        if (!moment(filters.DateStart).isValid()) {
            return showAlert({ type: "warning", message: "Ingresa una fecha de inicio valida" });
        }
        if (!moment(filters.DateEnd).isValid()) {
            return showAlert({ type: "warning", message: "Ingresa una fecha de fin valida" });
        }

        if (moment(filters.DateStart).isAfter(moment(filters.DateEnd))) {
            return showAlert({ type: "warning", message: "Ingresa un rango de fechas valido" });
        }

        GenerateReport(filters);
    }
    //#endregion

    render() {
        const {
            // Standard Props
            ListReports,
            ShowPDFViewerModal,
            ShowPDFViewer,
            ReportsModel,
            MailTools,
            printhide,
            ShowFormatToPrint,
        } = this.props;
        const {
            filters
        } = this.state;

        return (
            <div className="no-select">
                <div id="ReportProdOpenDocs" className="modal fade bd-example-modal-lg">
                    <div className="modal-dialog modal-dialog-centered modal-md" role="document" >
                        <div className="modal-content">
                            <div className="modal-header text-white" style={{backgroundColor:"#343a40",borderRadius:"0"}}>
                                <h4 className="modal-title" id="modal-basic-title "> Reporte de Cartera de Crédito</h4>
                                <button type="button" className="close" onClick={this.close} aria-label="Close">
                                    <span className="text-white" aria-hidden="true">&times;</span>
                                </button>
                            </div>

                            <div className="modal-body">
                                <div className="row mt-3">
                                    <div className="col-12 input-group mb-3">
                                        <div className="input-group-prepend ">
                                            <label className="input-group-text font-weight-bold" htmlFor="txtDateStart"> Desde </label>
                                        </div>
                                        <input
                                            id="txtDateStart"
                                            className="form-control"
                                            type="date"
                                            value={filters.DateStart}
                                            onChange={({target: { value }}) => this.updateField("DateStart", value)} />
                                    </div>
                                    <div className="col-12 input-group mb-3">
                                        <div className="input-group-prepend ">
                                            <label className="input-group-text font-weight-bold" htmlFor="txtDateEnd"> Hasta </label>
                                        </div>
                                        <input
                                            id="txtDateEnd"
                                            className="form-control"
                                            type="date"
                                            value={filters.DateEnd}
                                            onChange={({target: { value }}) => this.updateField("DateEnd", value)} />
                                    </div>
                                    <div className="col-12 input-group mb-3">
                                        <div className="input-group-prepend ">
                                            <label className="input-group-text font-weight-bold" htmlFor="txtStatus"> Estatus </label>
                                        </div>
                                        <select
                                            id="txtStatus"
                                            className="form-control"
                                            value={filters.Status}
                                            onChange={({target: { value }}) => this.updateField("Status", value)} >
                                                <option value=""> Todos </option>
                                                <option value="P"> Planificado </option>
                                                <option value="R"> Liberado </option>
                                        </select>
                                    </div>
                                </div>
                            </div>

                            <div className="modal-footer">
                            <button type="button" className="btn botonCerrar text-white" onClick={this.close}>Cerrar</button>
                            <button type="button" className="btn btn-primary" onClick={this.validateFilters}>Generar</button>
                            </div>
                        </div>
                    </div>
                </div>

                {ShowPDFViewerModal &&
                    <PdfViewer
                        DocsToPrint={ListReports}
                        TypeDoc={"ReportProdOpenDocs"}
                        EnableEditButton={false}
                        Editable={false}
                        ChangeEditableMode={false}
                        EditableDocModel={"SalesTools.EditableDocModel"}
                        RefreshDocModel={"SalesTools.RefreshDocModel"}
                        SaveChanges={"SalesTools.SaveChangesOrderInvoice"}
                        UploadDoc={"SalesTools.UploadInvoice"}
                        EditParam1={false}
                        ShowPDFViewer={ShowPDFViewer}
                        user={"user"}
                        Counter={true}
                        MailTools={MailTools}
                        ReportsModel={ReportsModel}
                        printhide={printhide}
                        ShowFormatToPrint={ShowFormatToPrint}
                        reprint={false} />
                }
            </div>
        );
    }
}

export default ReportProdOpenDocs;